import React, { useEffect, useState } from 'react';
import { CardBody, Input, Label } from 'reactstrap';

type CheckBoxOption = {
  label: string;
  value: string;
  checked: boolean;
};

type Props = {
  data: CheckBoxOption[];
  onCheckedChange?: (checkedItems: string[]) => void;
  style?: React.CSSProperties;
  disabled?:boolean
};

const ReusableCheckBox: React.FC<Props> = ({ data, onCheckedChange, style,disabled }) => {
  const [checkboxData, setCheckboxData] = useState<CheckBoxOption[]>(data);

  useEffect(() => {
    setCheckboxData(data);
  }, [data]); // <- Watches changes to data prop

  // Handle Checkbox Change
  const handleCheckboxChange = (index: number) => {
    const updatedData = [...checkboxData];
    updatedData[index].checked = !updatedData[index].checked;
    setCheckboxData(updatedData);

    // Notify Parent Component if callback exists
    if (onCheckedChange) {
      const checkedItems = updatedData.filter(item => item.checked).map(item => item.value);
      onCheckedChange(checkedItems);
    }
  };

  // Get Checked Values (for programmatic use)
//   const getCheckedValues = () => {
//     return checkboxData.filter(item => item.checked).map(item => item.value);
//   };

  return (
    <CardBody className="checkbox-checked" style={style}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
        {checkboxData.map((item, index) => (
          <div key={item.value} style={{ display: 'flex', alignItems: 'flex-start' }}>
            <Input
              type="checkbox"
              checked={item.checked}
              onChange={() => handleCheckboxChange(index)}
              style={{ marginRight: '6px' }}
              disabled={disabled}
            />
            <Label check>{item.label}</Label>
          </div>
        ))}
      </div>
      {/* <button onClick={() => console.log(getCheckedValues())}>Get Checked Values</button> */}
    </CardBody>
  );
};

export default ReusableCheckBox;
